import React from 'react';
import { Navigate } from 'react-router';
import DevPage from '../pages/Development.page';
import UserPage from '../pages/User.page';
import UserNewPage from '../pages/UserNew.page';
import UsersPage from '../pages/Users.page';
import { pagesAccess } from './accessMap';
import SignInPage from '../pages/SignIn.page';
import { IUser } from '../model/IUser';
import AccountPage from '../pages/Account.page';
import RolesPage from '../pages/Roles.page';
import VendorsPage from '../pages/Vendors.page';
import VendorNewPage from '../pages/VendorNew.page';
import VendorPage from '../pages/Vendor.page';

export interface IMapItem {
  path: string;
  element: React.ReactNode;
  children?: IMapItem[];
}

export const siteMap = (
  originalAddress: string,
  getPageAccess: (pageUrl: keyof typeof pagesAccess) => boolean,
  user?: IUser | null,
): IMapItem[] => [ 
  // -- 
  // -- Development routes
  // --
  {
    path: '/dev',
    element:  (getPageAccess('/dev') ? <DevPage /> : <Navigate to='/oauth/signIn?original-url=' />),
  },

  {
    path: '/',
    element:  (
      (getPageAccess('/users') && <Navigate to='/users' />)
      || (getPageAccess('/account') && <Navigate to='/account' />)
      || <Navigate to='/oauth/signIn?original-url=/' />
    ),
  },

  // -- 
  // -- Users routes
  // --
  {
    path: '/users',
    element:  (getPageAccess('/users') ? <UsersPage /> : <Navigate to='/' />),
  },
  {
    path: '/users/new',
    element:  (getPageAccess('/users/new') ? <UserNewPage /> : <Navigate to='/' />),
  },
  {
    path: '/users/:idUser',
    element:  (getPageAccess('/users') || getPageAccess('/account') ? <UserPage /> : <Navigate to='/' />),
  },
  {
    path: '/account',
    element:  (getPageAccess('/account') ? <AccountPage /> : <Navigate to='/oauth/signIn?original-url=/account' />),
  },

  // --
  // -- Roles
  // --
  {
    path: '/roles',
    element:  (getPageAccess('/roles') ? <RolesPage /> : <Navigate to='/oauth/signIn?original-url=/account' />),
  },

  // --
  // -- Vendors
  // --
  {
    path: '/vendors',
    element:  (getPageAccess('/vendors') ? <VendorsPage /> : <Navigate to='/' />),
  },
  {
    path: '/vendors/new',
    element:  (getPageAccess('/vendors/new') ? <VendorNewPage /> : <Navigate to='/' />),
  },
  {
    path: '/vendors/:idVendor',
    element:  (getPageAccess('/vendors') ? <VendorPage /> : <Navigate to='/' />),
  },

  // -- 
  // -- Ouath routes
  // --
  {
    path: '/oauth/signIn',
    element:  <SignInPage />,
  },

  // -- 
  // -- Other routes
  // --
  {
    path: '*',
    element: <Navigate to='/users' />,
  },
];

